const Routes = {
  DEFAULT: '/',
  WELCOME: 'welcome',
  LOGIN: 'login',
  OTP: 'otp',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  SIGNUP: 'signup',
  SIGNUP_STEP2: 'step2',
  SIGNUP_STEP3: 'step3',
  TRANSACTIONS: 'transactions',
  TRANSACTIONS_DETAILS: 'transactions-details',
  SETTLEMENTS: 'settlements',
  SETTLEMENT_DETAILS: 'settlement-details',
  INSIGHTS: 'insights',
  VAULT: 'vault',
  INITIATEREFUNDS: 'initiate-refunds',
  HOME: 'home',
  DISPUTES: 'disputes',
  REFUNDS: 'refunds',
  SUPPORT: '/support',
  FAQS: '/faqs',
  CONTACT: 'contact-us',
  LANDING_CONTACT: '/jiopay/contact',
  MERCHANT_AGREEMENT: '/agreement',
  TERMS_OF_USE: '/tnc',
  PRIVACY_POLICY: '/privacy',
  NUMBER: 'number',
  EMAIL: 'email',
  PROFILE: 'profile',
  PROFILE_PASSWORD: 'password',
  PROFILE_NUMBER: 'number',
  PROFILE_EMAIL: 'email',
  UPGRADE_ACC: 'upgrade',
  PAYMENT_SETTLEMENTS: 'pay-settle',
  DOCUMENTS: 'documents',
  NOTIFICATIONS: 'notifications',
  BLOCK_UNBLOCK_ACC: 'blockunblock',
  EDIT_BUSINESS_DETAILS: 'editbusiness',
  EDIT_RES_ADDRESS: 'editresidentialaddress',
  EDIT_BUSS_ADDRESS: 'editbusinessaddress',
  EDIT_GST_DETAILS: 'editgst',
  EDIT_PAY_SETTLEMENT: 'editpaysettlement',
  EDIT_NOTIFICATION_NUMBER: 'editnotificationsnumber',
  EDIT_NOTIFICATION_EMAIL: 'editnotificationsemail',
  EDIT_DOCUMENTS: 'editdocuments',
  BULK_REFUND: 'bulkrefund',
  BULK_REPORT: '/bulkrefund/report',
  BULK_SUMMARY: '/bulkrefund/summary',
  INVOICES: 'invoices',
  MARKETING: 'marketing',
  LANDING_PAGE: 'jiopay',
  TRX_INITIATEREFUND: '/transactions/initiate-refunds',
  REFUND_INITIATEREFUND: '/refunds/initiate-refunds',
  SUBSCRIPTION_INITIATEREFUND: '/subscriptions/initiate-refunds',
  HOME_INITIATEREFUND: 'initiate-refunds',
  SETTINGS: 'settings',
  UPIQRCODE: 'UpiQRCode',
  QR_CODE: 'qr',
  HOW_TO_VIDEO: 'HowToVideo',
  ADD_ACCNT: 'addaccounts',
  SELECT_BANK: 'selectbank',
  ADD_BANK: 'addbank',
  SUCCESS: 'success',
  SEARCH: 'search',
  BANKACCOUNT: 'BankAccountDetails',
  DASHBOARD: 'root',
  ROOTSCREEN: 'root',
  QR_AGENT_PORTAL: 'QrAgentPortal',
  RECENTS: 'home',
  PAYMENT_LINKS: 'paymentlinks',
  SUBSCRIPTIONS: 'subscriptions',
  SPLASH: 'splash',
  BANK_ACC_DETAIL: 'BankAccountDetails',
  CREATE_PAYMENT_LINK: 'CreatePaymentLink',
  SUBSCRIPTION_FILTER: 'SubscriptionFilter',
  USER_MANAGEMENT: {
    INTRO: 'info',
    VIEW_USERS: 'viewusers',
    ADD_NEW_USER: 'AddNewUser',
    EDIT_USER_ROLE: 'EditUserRole',
    MANAGE_USERS: 'manageusers',
    ADD_USER_MOBILE: 'addnewuser',
    EDIT_USER_ROLE_MOBILE: 'edituserrole',
    USER_DETAILS_MOBILE: 'userdetails',
  },
  CAMPAIGNS: 'campaigns',
  CREATE_CAMPAIGN: '/campaigns/createcampaign',
  CAMPAIGN_DETAILS: '/campaigns/details',
  CONTACT_US_LOGIN: 'contact-customer-support',
  LINKS: 'links',
  DOWNLOADS: 'reports',
  SETTLEMENTS_REPORTING: 'settlements-reporting',
  SETTLEMENTS_ADD_UPDATE_REPORT: 'settlements-add-update',
  DOWNLOADS_TXNS: 'reports/transaction',
  DOWNLOADS_SETTLEMENTS: 'reports/settlement',
  DOWNLOADS_REFUNDS: 'reports/refund',
  REPORT_CONFIGURATION: 'report-configuration',
  QrAgentLogin: 'QrAgentLogin',
  QrAgentOtp: 'QrAgentOtp',
  scanqr: 'scanqr',
  midslist: 'midslist',
  review: 'review',
  status: 'status',
  NOTIFICATION_SETTINGS: 'notificaton-settings',
  VAULT_TOKENIZATION: 'tokenizationRequests',
  MY_DEVICES: 'MyDevices',
  VOICEBOX: 'VOICEBOX',
  RENTAL_HISTORY: 'rentalHistory',
  CHATBOT: 'chatBot',
  // BENEFICIARY_ONBOARDING: 'beneficiaryOnboarding',
  PAYOUTS: 'payouts',
  PAYOUTS_HISTORY: 'payoutshistory',
  PAYOUTS_BENEFICIARY: 'beneficiaryOnboarding',
  PAYOUTS_LINK: 'payoutslink',
  BILL_PAYMENTS: 'billPayments',
  OPERATOR_LIST: 'OperatorList',
  BILL_FETCH: 'BillFetch',
  AUTH_INPUT: 'AuthInput',
  TXN_STATUS: 'TxnStatus',
  BILL_PAYMENTS_TRANSACTIONS: 'billpaytransactions',
  BILLPAY_SEARCH: '/search',
  SELECT_CITY: '/select-city',
  INSTITUTE_LIST: '/institute-list',
  BILL_PAYMENTS_TRANSACTIONS_DETAILS: '/billpaytxndetails',
  BILL_PAYMENTS_DETAILS: 'billpaymentdetails',
  HELP_AND_SUPPORT: 'help-and-support',
  SUPERSET_DASHBOARD: 'analyticalDashboard',
}

const RoutePath: any = {
  DEFAULT: '/',
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgotPassword',
  RESET_PASSWORD: 'resetPassword',
  OTP: 'otp',
  SIGNUP: 'signup',
  SIGNUP_STEP2: 'step2',
  SIGNUP_STEP3: 'step3',
  TRANSACTIONS: 'transactions',
  SETTLEMENTS: 'settlements',
  HOME: 'home',
  DISPUTES: 'disputes',
  REFUNDS: 'refunds',
  SUPPORT: 'support',
  FAQS: 'faqs',
  CONTACT: 'contact',
  LANDING_CONTACT: 'talktous',
  MERCHANT_AGREEMENT: 'agreement',
  TERMS_OF_USE: 'tnc',
  PRIVACY_POLICY: 'privacy',
  NUMBER: 'number',
  EMAIL: 'email',
  PROFILE: 'profile',
  PROFILE_PASSWORD: 'password',
  PROFILE_NUMBER: 'number',
  PROFILE_EMAIL: 'email',
  UPGRADE_ACC: 'upgrade',
  PAYMENT_SETTLEMENTS: 'pay-settle',
  DOCUMENTS: 'documents',
  NOTIFICATIONS: 'notifications',
  BLOCK_UNBLOCK_ACC: 'blockunblock',
  EDIT_BUSINESS_DETAILS: 'editbusiness',
  EDIT_RES_ADDRESS: 'editresidentialaddress',
  EDIT_BUSS_ADDRESS: 'editbusinessaddress',
  EDIT_GST_DETAILS: 'editgst',
  EDIT_PAY_SETTLEMENT: 'editpaysettlement',
  EDIT_NOTIFICATION_NUMBER: 'editnotificationsnumber',
  EDIT_NOTIFICATION_EMAIL: 'editnotificationsemail',
  EDIT_DOCUMENTS: 'editdocuments',
  BULK_REFUND: 'bulkrefund',
  BULK_REPORT: 'report',
  BULK_SUMMARY: 'summary',
  LANDING_PAGE: 'jiopay',
  INITIATEREFUNDS: 'initiate-refunds',
  SETTINGS: 'setting',
  SEARCH: 'search',
  DOWNLOADS: 'reports',
  SETTLEMENTS_REPORTING: 'settlements-reporting',
  SETTLEMENTS_ADD_UPDATE_REPORT: 'settlements-add-update',
  SUBSCRIPTIONS: 'subscriptions',
}
const RouteName: any = {
  DEFAULT: 'Home',
  LOGIN: 'Login',
  FORGOT_PASSWORD: 'Forgot Password',
  RESET_PASSWORD: 'Set new password',
  OTP: 'Enter OTP',
  SIGNUP: 'Sign Up Step 1',
  SIGNUP_STEP2: 'Sign Up Step 2',
  SIGNUP_STEP3: 'Sign Up Step 3',
  TRANSACTIONS: 'Transactions',
  SETTLEMENTS: 'Settlements',
  DISPUTES: 'Disputes',
  REFUNDS: 'Refunds',
  SUPPORT: 'Support',
  FAQS: "Faq's",
  CONTACT: 'Contact us',
  MERCHANT_AGREEMENT: 'Agreement',
  TERMS_OF_USE: 'Terms & Conditions',
  PRIVACY_POLICY: 'Privacy Policy',
  PROFILE: 'Profile',
  PROFILE_PASSWORD: 'Change Password',
  PROFILE_NUMBER: 'Change Mobile Number',
  PROFILE_EMAIL: 'Change Email & Web',
  UPGRADE_ACC: 'Upgrade Account',
  PAYMENT_SETTLEMENTS: 'Payments & Settlements',
  DOCUMENTS: 'Documents',
  NOTIFICATIONS: 'Notifications',
  BLOCK_UNBLOCK_ACC: 'Block Unblock Account',
  EDIT_BUSINESS_DETAILS: 'Update Business Details',
  EDIT_RES_ADDRESS: 'Update Residential Address',
  EDIT_BUSS_ADDRESS: 'Update Business Address',
  EDIT_GST_DETAILS: 'Update GST Details',
  EDIT_PAY_SETTLEMENT: 'Update Payments & Settlements',
  EDIT_NOTIFICATION_NUMBER: 'Update Notifications Number',
  EDIT_NOTIFICATION_EMAIL: 'Update Notifications Email',
  EDIT_DOCUMENTS: 'Update Documents',
  BULK_REFUND: 'Bulk Refund',
  BULK_REPORT: 'Bulk Refund Report',
  BULK_SUMMARY: 'Bulk Refund Summary',
  LANDING_PAGE: 'Landing',
  INITIATEREFUNDS: 'Refund Transactions',
  SETTINGS: 'setting',
  DOWNLOADS: 'reports',
  SUBSCRIPTIONS: 'Subscriptions',
}

const getPathName = (path: string): string => {
  let name = ''
  Object.keys(RoutePath).map((key) => {
    if (RoutePath[key] === path) {
      name = RouteName[key]
    }
    return name
  })
  return name
}

export { RouteName, RoutePath, Routes, getPathName }
